export default "__VITE_ASSET__DiAGP9gm__"